/**
 * "Repasar ahora": what the button on Inicio announces.
 *
 * The plan is the session queue itself: the same scheduler call that
 * useSession makes when the button is pressed. The number on the button is
 * therefore exactly what will be studied (overdue + today + new, with the same
 * limits). Inicio's only count until now («Vencidos · N») added the due and
 * overdue cards of the decks flagged as overdue: it left out new cards and
 * decks merely due today, so it matched no session (audit §5.3).
 */
import type { StateDBService } from '../db/state-db-service.ts'
import type { UserSettings } from '../../types/domain.ts'
import { SessionScheduler } from './session-scheduler.ts'

export interface ReviewNowPlan {
  /** Cards the session will hold, every segment included. */
  cards: number
  /** Estimated minutes for all of them. */
  minutes: number
  /** Decks they come from. */
  decks: number
}

export async function planReviewNow(service: StateDBService, settings: UserSettings, nowTs?: number): Promise<ReviewNowPlan> {
  const instances = await service.getDeckInstances()
  const queue = await new SessionScheduler(service).buildMixedQueue(instances, settings, nowTs)
  return {
    cards: queue.cards.length,
    minutes: queue.estimated_minutes,
    decks: new Set(queue.cards.map((c) => c.deck_instance_id)).size,
  }
}
